import React from 'react'
import ContainerSectionSpecialtiesCircular from './styles'
import ArrowCurvedSVG from '../../../../assets/svgs/arrow-curved'
import useAppConfig from '../../../../hooks/useAppConfig'

export default function SectionSpecialtiesCircular() {
  const { appConfig } = useAppConfig()
  return (
    <ContainerSectionSpecialtiesCircular
      color={
        appConfig?.appConfig?.styles?.forceSecondaryColor ? 'true' : undefined
      }
    >
      <div className="middle-section">
        <div className="m-s-top">
          <div className="m-s-t-left">
            <div className="m-s-t-l-label">
              {appConfig?.appConfig?.specialties?.label ?? 'SPECIALTIES'}
              <span>
                <ArrowCurvedSVG />
              </span>
            </div>
            <div className="m-s-t-l-title">
              {appConfig?.appConfig?.specialties?.title ??
                'Experiencing Traditions Cultural Immersion'}
            </div>
          </div>
        </div>
        <div className="m-s-bottom">
          <div className="m-s-b-left">
            {appConfig?.appConfig?.specialties?.specialtiesList
              ?.slice(0, 4)
              .map((specialty, _index) => {
                return (
                  <div
                    className="specialty-list-item"
                    key={`specialty-list-item-${_index}`}
                  >
                    <div className="specialty-list-item-image">&nbsp;</div>
                    <div className="specialty-list-item-title">
                      {specialty.title}
                    </div>
                    <div className="specialty-list-item-description">
                      {specialty.description}
                    </div>
                  </div>
                )
              })}
          </div>
          <div className="m-s-b-right">&nbsp;</div>
        </div>
      </div>
    </ContainerSectionSpecialtiesCircular>
  )
}
